<template>
  <div class="g-bd">
    <!-- banner -->
    <div class="con-banner">
      <el-carousel trigger="click" height="400px" arrow="never">
        <a
          v-for="item in bannerList"
          :key="item.id"
          @click="changeBanner(item)"
        >
          <el-carousel-item
            :style="`background:${item.backgroundColor};background-size: cover;
-webkit-background-size: cover;
-o-background-size: cover;
zoom: 1;`"
          >
            <div
              :class="
                $route.query.siteId == 6 ? 'item-con rural-promote' : 'item-con'
              "
            >
              <img :src="imgUrl + item.path" alt />
            </div>
          </el-carousel-item>
        </a>
      </el-carousel>
    </div>
    <div class="container course-list">
      <!-- <el-button type="primary" @click="openVideo(file)"></el-button> -->
      <div class="list-content">
        <div
          class="con-list f-clearfix"
          v-for="(item, index) in courseList"
          :key="index"
        >
          <div class="body-tool course-tool">
            <h2>{{ item.title }}</h2>
            <span><a :href="item.link" target="_blank">查看更多 &gt;</a></span>
            <!-- @click="toCourseList(item)" -->
          </div>
          <ul class="index-course f-clearfix">
            <li
              v-for="(child, index) in item.courseList"
              :key="index"
              :title="child.name"
            >
              <a :href="child.link" target="_blank">
                <!-- target="_blank" -->
                <div class="item-img">
                  <img v-img.lazy="child.img" :alt="child.name" />
                </div>
                <p class="item-title">{{ child.title }}</p>
                <div>
                  <span class="item-school">{{ child.school }}</span>
                  <span>{{ child.teacher }}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="850px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      v-if="dialogVisible"
    >
      <video width="800" height="400" controls autoplay="autoplay">
        <source
          src="http://jdvoddcbardve.vod.126.net/jdvoddcbardve/n06I8GsS_3532875696_shd.mp4"
          type="video/mp4"
        />
      </video>
      <!-- <video id="my-video" :options="video" class="video-js" width="800" height="400"></video> -->
    </el-dialog>
  </div>
</template>
<script>
// import videojs from "video.js";
// import videojsResolutionSwitcher from "@/components/video/videoResolution";
// import "@/components/video/videoLanguage";
// import "video.js/dist/video-js.css";
// import neplayer from "@/common/neplayer/neplayer.min.js";
// import "@/common/neplayer/neplayer.min.css";
// import "videojs-flash";
export default {
  data () {
    return {
      imgUrl: this.$setting.fdsDomain,
      dialogVisible: false,
      dialogTitle: "",
      bannerList: [],
      sortType: '',
      file: {
        title: "123",
        fileUrl: "testVideo.mp4"
      },
      video: null,
      courseList: [
        {
          title: "乡村党建",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860172?tid=1467971459",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860172?tid=1467971459",
              img: "/images/rural-image/type_row_1_01.png",
              school: "东南大学",
              title: "百年沧桑话复兴一一社会现代化的“中国 故事”",
              teacher: "朱菊生"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860172?tid=1467971459",
              img: "/images/rural-image/type_row_1_02.png",
              school: "南京信息工程大学",
              title: "青年在新时代乡村振兴中的品格锤炼一读《习近平的七年知青岁月》",
              teacher: "朱亚宾"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860172?tid=1467971459",
              img: "/images/rural-image/type_row_1_03.png",
              school: "江苏航运职业技术学院",
              title: "中国共产党为什么“能”：百年乡村见天地",
              teacher: "赵小青"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860172?tid=1467971459",
              img: "/images/rural-image/type_row_1_04.png",
              school: "江苏开放大学",
              title: "“红船精神”",
              teacher: "陆洋"
            }
          ]
        },
        {
          title: "三农政策",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466857176",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466857176",
              img: "/images/rural-image/type_row_2_01.png",
              school: "南京大学",
              title: "乡村住宅建设用地支持政策",
              teacher: "钟太洋"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466857176",
              img: "/images/rural-image/type_row_2_02.png",
              school: "南京邮电大学",
              title: "从《乡村振兴促进法》看乡村生态保护",
              teacher: "任洁"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466857176",
              img: "/images/rural-image/type_row_2_03.png",
              school: "常熟理工学院",
              title: "实施乡村振兴战略金融政策解读",
              teacher: "吴敏艳"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466857176",
              img: "/images/rural-image/type_row_2_04.png",
              school: "淮阴工学院",
              title: "种子法以案说法",
              teacher: "陈明"
            }
          ]
        },
        {
          title: "科学种地",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466855168",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466855168",
              img: "/images/rural-image/type_row_3_01.png",
              school: "南京农业大学",
              title: "水稻高质高效栽培理论与技术",
              teacher: "李刚华"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466855168",
              img: "/images/rural-image/type_row_3_02.png",
              school: "中国药科大学",
              title: "根茎类中药材一一天麻、黄连",
              teacher: "毕志明"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466855168",
              img: "/images/rural-image/type_row_3_03.png",
              school: "南京林业大学",
              title: "核桃常见病害及其防治技术",
              teacher: "黄麟"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466855168",
              img: "/images/rural-image/type_row_3_04.png",
              school: "苏州农业职业技术学院",
              title: "温室番茄岩棉栽培技术",
              teacher: "陈素娟"
            }
          ]
        },
        {
          title: "养殖天地",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466865175",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466865175",
              img: "/images/rural-image/type_row_4_01.png",
              school: "扬州大学",
              title: "鸡球虫病的诊断",
              teacher: "陶建平"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466865175",
              img: "/images/rural-image/type_row_4_02.png",
              school: "江苏农牧科技职业学院",
              title: "畜禽常用疫苗实用技术",
              teacher: "陆辉、刘玉华"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466865175",
              img: "/images/rural-image/type_row_4_03.png",
              school: "苏州大学",
              title: "蚕桑规模化生产技术",
              teacher: "李兵"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466865175",
              img: "/images/rural-image/type_row_4_04.png",
              school: "江苏农林职业技术学院",
              title: "鱼类增养殖技术",
              teacher: "王会聪"
            }
          ]
        },
        {
          title: "农产加工",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466883169",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466883169",
              img: "/images/rural-image/type_row_5_01.png",
              school: "江南大学",
              title: "速冻鱼丸制作",
              teacher: "范大明"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466883169",
              img: "/images/rural-image/type_row_5_02.png",
              school: "江苏食品药品职业技术学院",
              title: "粮品类掺伪鉴别检验",
              teacher: "鲍会梅"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466883169",
              img: "/images/rural-image/type_row_5_03.png",
              school: "南京晓庄学院",
              title: "乡村振兴农产品冷链大有可为",
              teacher: "陈守江"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466883169",
              img: "/images/rural-image/type_row_5_04.png",
              school: "江苏建筑职业技术学院",
              title: "农产品运输管理一一运输环境中影响品质的因素",
              teacher: "靖培星"
            }
          ]
        },
        {
          title: "农产贸易",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860171",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860171",
              img: "/images/rural-image/type_row_6_01.png",
              school: "中国矿业大学",
              title: "农业经济新特征及其发展趋势",
              teacher: "王超"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860171",
              img: "/images/rural-image/type_row_6_02.png",
              school: "无锡职业技术学院",
              title: "如何开启一场农产品直播",
              teacher: "乔巍"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860171",
              img: "/images/rural-image/type_row_6_03.png",
              school: "镇江市高等专科学院",
              title: "农产品电子商务之商品信息编辑",
              teacher: "翁瑾"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466860171",
              img: "/images/rural-image/type_row_6_04.png",
              school: "扬州市职业大学",
              title: "农产品手机拍摄与直播拍摄技巧一一花卉拍摄专题",
              teacher: "顾庆龙、王清"
            }
          ]
        },
        {
          title: "智慧农业",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466878169",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466878169",
              img: "/images/rural-image/type_row_7_01.png",
              school: "河海大学",
              title: "活水工程对湖泊水环境质量改善效果评估",
              teacher: "李一平"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466878169",
              img: "/images/rural-image/type_row_7_02.png",
              school: "南京理工大学",
              title: "无人机世界的“智慧农业”",
              teacher: "殷齐闯"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466878169",
              img: "/images/rural-image/type_row_7_03.png",
              school: "江苏大学",
              title: "种植机械技术",
              teacher: "胡建平"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466878169",
              img: "/images/rural-image/type_row_7_04.png",
              school: "南京航空航天大学",
              title: "北斗导航卫星一一在智慧农业中的应用与案例",
              teacher: "闻新"
            }
          ]
        },
        {
          title: "乡村教育",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466862173",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466862173",
              img: "/images/rural-image/type_row_8_01.png",
              school: "南京师范大学",
              title: "乡村儿童的幼小衔接",
              teacher: "郭媛媛"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466862173",
              img: "/images/rural-image/type_row_8_02.png",
              school: "南通大学",
              title: "学校体育学一一体育教学方法",
              teacher: "陈新华"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466862173",
              img: "/images/rural-image/type_row_8_03.png",
              school: "盐城师范学院",
              title: "乡村儿童声乐训练探索",
              teacher: "孙新宇"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466862173",
              img: "/images/rural-image/type_row_8_04.png",
              school: "徐州幼儿师范高等专科学校",
              title: "学前儿童行为观察与指导",
              teacher: "罗秋英"
            }
          ]
        },
        {
          title: "健康生活",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466863168",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466863168",
              img: "/images/rural-image/type_row_9_01.png",
              school: "南京中医药大学",
              title: "感冒的预防、治疗与调护",
              teacher: "严妹霞"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466863168",
              img: "/images/rural-image/type_row_9_02.png",
              school: "江苏海事职业技术学院",
              title: "农民劳作中受伤如何止血？",
              teacher: "李俐、张荣军、赵默洋"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466863168",
              img: "/images/rural-image/type_row_9_03.png",
              school: "江苏卫生健康职业学院",
              title: "儿童心肺复苏",
              teacher: "朱丽华"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466863168",
              img: "/images/rural-image/type_row_9_04.png",
              school: "南京体育学院",
              title: "一起来练五禽戏",
              teacher: "刘靖"
            }
          ]
        },
        {
          title: "美丽乡村",
          link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466886164",
          courseList: [
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466886164",
              img: "/images/rural-image/type_row_10_01.png",
              school: "南京艺术学院",
              title: "美丽乡村宣推与新媒体策划",
              teacher: "陈丽君"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466886164",
              img: "/images/rural-image/type_row_10_02.png",
              school: "南京工程学院",
              title: "推进美丽乡村建设，生活污水治理先行",
              teacher: "徐进"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466886164",
              img: "/images/rural-image/type_row_10_03.png",
              school: "江苏警官学院",
              title: "乡村电动自行车交通安全治理",
              teacher: "郏红雯"
            },
            {
              link: "https://www.icourse163.org/spoc/course/CRJYYJH-1466886164",
              img: "/images/rural-image/type_row_10_04.png",
              school: "南京信息职业技术学院",
              title: "农村垃圾分类与资源化利用",
              teacher: "孙凤梅、秋珊珊、张君"
            }
          ]
        },
      ],
    };
  },
  watch: {
    sortType (v) {
      this.newPageList.pageNo = 1;
      this.getCourse();
    },
  },
  mounted () {
    this.getbanner();
    console.log(this.$router.query)
  },
  methods: {
    changeBanner (item) {
      switch (item.sortId) {
        case 2:
          window.open('/ruralList');
          break;
        case 3:
          this.dialogVisible = true
          break;
        // case 3:
        //   if(item.linkUrl!=''){
        //     window.open(item.linkUrl);
        //   }
        //   break;

        default:
          if (item.linkUrl != '') {
            window.open(item.linkUrl);
          }
          break;
      }
    },
    initVideo () {
      //初始化视频方法
      this.video = videojs("my-video", {
        language: "zh-CN",
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "true",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "800px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px",
        src: "testVideo.mp4"
      });
    },
    openVideo (val) {
      this.dialogVisible = true;
      this.dialogTitle = val.title;
      // if (!this.video) {
      //   this.$nextTick(() => {
      //     this.initVideo();
      //     this.video.src(this.getUrl(val.fileUrl));

      //   });
      // } else {
      //   this.$nextTick(() => {
      //     this.video.src(this.getUrl(val.fileUrl));
      //     this.video.load();
      //   });
      // }
    },
    getUrl (url) {
      if (!url) {
        return url;
      }
      if (url.startsWith("http")) {
        return url;
      } else {
        return this.imgUrl + url;
      }
    },
    handleClose () {
      this.dialogVisible = false
    },
    getbanner () {
      let par = {
        tagCourseId: 5,
      };
      this.$http.post("/api/web/banner/list", par).then((res) => {
        this.bannerList = res.data;
        // this.sysCountPV();
      });
    },
    newPage (val) {
      this.newPageList.pageNo = val;
      this.getCourse();
    },
    toCourseList (item) {
      window.open(item.link);
    },
  },
};
</script>
<style lang="scss" scoped>
.g-bd {
  min-height: calc(100vh - 168.6px);
}
.con-banner {
  height: 400px;
  width: 100%;
  margin: 0 auto;
  // overflow: hidden;
  display: flex;
  justify-content: space-between; // position: relative;

  .el-carousel {
    flex: 1;
    overflow: hidden;
    .el-carousel__container {
      margin: 0 auto;
      .item-con {
        position: relative;
        height: 400px;
        margin: 0 auto;
        width: auto;
        display: flex;
        justify-content: center;
        align-content: center;
      }
    }
  }

  .el-carousel__item img {
    // width: 100%;
    height: 100%;
    margin: 0 auto;
    display: block;
  }
}
.body-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    font-size: 26px;
  }
  span {
    font-size: 14px;
    color: #777;
    cursor: pointer;
    &:hover {
      color: #4da5f7;
    }
  }
}
.course-list {
  margin: 30px auto;
}
.index-course {
  overflow: hidden;
  margin-top: 20px;
  :nth-child(4n) {
    margin-right: 0px;
  }
  li {
    float: left;
    width: 280px;
    margin-right: 26px;
    margin-bottom: 26px;
    position: relative;
    a:hover {
      color: #2f3440;
    }
    .item-img {
      width: 280px;
      height: 160px;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
      }
    }
    .item-title {
      height: 44px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 5px 0;
    }
    h3 {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 40px;
    }
    .item-teacher {
      height: 20px;
    }
    div {
      // height: 40px;
      // line-height: 40px;
      span {
        color: #777;
        font-size: 12px;
        float: left;
      }
      .item-school {
        margin-right: 10px;
      }
      .item-edu {
        float: right;
        text-align: right;
      }
    }
    &:hover {
      cursor: pointer;
      img {
        opacity: 0.8;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
.video-demo {
  &:focus {
    outline: none;
  }
}
</style>